import { render } from "./VatFields.vue?vue&type=template&id=6b8f3669&scoped=true"
import script from "./VatFields.vue?vue&type=script&lang=js"
export * from "./VatFields.vue?vue&type=script&lang=js"

import "./VatFields.vue?vue&type=style&index=0&id=6b8f3669&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8f3669"]])

export default __exports__